import { useState, useEffect } from 'react';
import { useAnnouncements } from '@/hooks/use-announcements';

const motivationalQuotes = [
  "Success is not final, failure is not fatal: it is the courage to continue that counts.",
  "The only way to do great work is to love what you do.",
  "Innovation distinguishes between a leader and a follower.",
  "Your time is limited, don't waste it living someone else's life.",
  "The best way to predict the future is to create it.",
  "Quality is not an act, it is a habit.",
  "Excellence is not a destination; it is a continuous journey that never ends.",
];

export const AnnouncementTicker = () => {
  const { announcements } = useAnnouncements();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const allMessages = [
    ...announcements.map(a => a.message),
    ...motivationalQuotes
  ];

  useEffect(() => {
    if (allMessages.length === 0) return;

    const interval = setInterval(() => {
      setIsVisible(false);
      
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % allMessages.length);
        setIsVisible(true);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, [allMessages.length]);

  if (allMessages.length === 0) return null;

  return (
    <div className="flex-1 overflow-hidden px-4">
      <div
        className={`text-sm text-muted-foreground transition-all duration-500 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
        }`}
      >
        <span className="font-medium text-primary">✨ </span>
        {allMessages[currentIndex]}
      </div>
    </div>
  );
};
